<template>
  <div>

    <h1>Sorry, something has gone wrong.</h1>
    <p>We couldn't collect payment for your booking. However, we have saved your booking request pending payment. Please get in touch with us on {{ phone_number }} to complete your booking.</p>

  </div>
</template>

<script>
export default {
  name: 'Failure',
}
</script>